import { useQuery } from "@tanstack/react-query"
import { getCommissionSummary, getMissingCommissions, getCommissionRows } from "@/api/commissions"
import { CommissionRow, CommissionSummary } from "@/types"

export const useCommissionSummary = () => {
  return useQuery<CommissionSummary[]>({
    queryKey: ["commissionSummary"],
    queryFn: () => getCommissionSummary(),
    staleTime: 1000 * 60 * 5,
  })
}

export const useCommissionRows = (personId?: number) => {
  return useQuery<CommissionRow[]>({
    queryKey: ["commissionRows", personId],
    queryFn: () => getCommissionRows({ personId }),
    staleTime: 1000 * 60 * 5,
    enabled: personId !== undefined,
  })
}

export const useMissingCommissions = () => {
  return useQuery<CommissionRow[]>({
    queryKey: ["missingCommissions"],
    queryFn: () => getMissingCommissions(),
    staleTime: 1000 * 60 * 5,
  })
}
